import { config } from './config';
import axios from 'axios';
import { ok, err } from 'neverthrow';
export const users = (() => {
    async function create(user) {
        try {
            const result = await axios.post(baseUrl(), user);
            if (result && result.status === 201) {
                return ok(result.data);
            }
            return err(result.data);
        }
        catch (error) {
            return err(error.response.data);
        }
    }
    async function retrieve(idOrUser) {
        if (idOrUser && typeof idOrUser !== 'number') {
            idOrUser = idOrUser.id;
        }
        if (typeof idOrUser === 'number') {
            try {
                const result = await axios.get(`${baseUrl()}/${idOrUser}`);
                if (result && result.status === 200) {
                    return ok(result.data);
                }
                return err(result.data);
            }
            catch (error) {
                return err(error.response.data);
            }
        }
        return err([
            {
                key: 'incorrect_data',
                message: 'please provide an id, or a (user) object with id',
                arguments: [],
            },
        ]);
    }
    async function queryUsers(query) {
        const params = { ...query };
        const requestConfig = { params: params };
        if (params.enabled === 'any') {
            params.enabled = undefined; //ignore send to backend!
        }
        //normalize role
        if (params.role &&
            typeof params.role !== 'string' &&
            'name' in params.role) {
            params.role = params.role.name;
        }
        try {
            const result = await axios.get(baseUrl(), requestConfig);
            if (result && result.status === 200) {
                return ok(result.data);
            }
            return err(result.data);
        }
        catch (error) {
            return err(error.response.data);
        }
    }
    async function update(user) {
        const userId = user && user.id ? user.id : undefined;
        const { password, id, email, ...requestBody } = { ...user }; // prepare request body
        if (!userId) {
            return err([
                {
                    key: 'incorrect_data',
                    message: 'please provide a (user) object with id',
                    arguments: [],
                },
            ]);
        }
        try {
            const result = await axios.put(`${baseUrl()}/${userId}`, requestBody);
            if (result && result.status === 200) {
                return ok(result.data);
            }
            return err(result.data);
        }
        catch (error) {
            return err(error.response.data);
        }
    }
    async function remove(idOrUser) {
        if (typeof idOrUser !== 'number') {
            idOrUser = idOrUser.id;
        }
        if (typeof idOrUser === 'number') {
            try {
                const result = await axios.delete(`${baseUrl()}/${idOrUser}`);
                if (result && result.status === 200)
                    return ok(true);
                return ok(false);
            }
            catch (error) {
                return err(error.response.data);
            }
        }
        return err([
            {
                key: 'incorrect_data',
                message: 'please provide an id, or a (user) object with id',
                arguments: [],
            },
        ]);
    }
    function baseUrl() {
        return `${config.fullUrl()}/users`;
    }
    return {
        create: create,
        get: retrieve,
        query: queryUsers,
        update: update,
        delete: remove,
    };
})();
